import { getElementExists } from "../../../resources/js/helper/helper";

(function () {
  // Classes
  const accordionContainerClass = ".com-accordion-faq";
  const accordionControlClass = ".accordion-control";
  const accordionTextClass = ".mb-tab__text";
  const accordionTabClass = ".com-accordion-faq__tab";

  // Data-Attributes
  const tabActivData = "data-tab-active";

  let documentWidth = document.body.clientWidth;

  /**
   * Setup Accordion
   */
  function setupAccodion() {
    const accordionContainer = document.querySelectorAll(
      accordionContainerClass
    );

    // For each Accordion-component
    for (let c = 0; c < accordionContainer.length; c++) {
      let accordionControls = accordionContainer[c].querySelectorAll(
        accordionControlClass
      );

      const accordionTabs =
        accordionContainer[c].querySelectorAll(accordionTabClass);

      // for each accordion tab
      for (let i = 0; i < accordionControls.length; i++) {
        accordionControls[i].addEventListener(
          "click",
          function (event) {
            onClickTab(i, accordionControls, accordionTabs);
          },
          false
        );
      }
    }
  }

  /**
   * Function to toggle clicked tab and deactivate the other
   * @param {int / index} i
   * @param {array [Elements]} accordionControls
   * @param {array [Elements]} accordionTabs
   */
  function onClickTab(i, accordionControls, accordionTabs) {
    if (accordionTabs == undefined || accordionControls == undefined) {
      return false;
    }

    console.log("test", accordionTabs[i].getAttribute(tabActivData) == "false");

    if (
      getElementExists(accordionTabs[i]) &&
      accordionTabs[i].getAttribute(tabActivData) == "false"
    ) {
      console.log(accordionTabs[i]);
      // Set Tab active
      accordionTabs[i].setAttribute(tabActivData, "true");
      accordionControls[i].setAttribute("aria-expanded", "true");

      // Open content
      let tabInner = accordionTabs[i].querySelector(accordionTextClass);
      tabInner.setAttribute("aria-hidden", "false");
      // Set max-height by content height
      tabInner.style.maxHeight = tabInner.scrollHeight + "px";

      // Reset other tabs
      resetTabs(accordionTabs, i);
    } else {
      // Reset active tab
      accordionTabs[i].setAttribute(tabActivData, "false");
      accordionControls[i].setAttribute("aria-expanded", "false");
      accordionTabs[i]
        .querySelector(accordionTextClass)
        .setAttribute("aria-hidden", "true");

      let tabInner = accordionTabs[i].querySelector(accordionTextClass);
      tabInner.setAttribute("aria-hidden", "true");
      tabInner.style.maxHeight = 0;
    }
  }

  /**
   * Reset active tabs
   * @param {array[dom]} accordionTabs
   * @param {int} keepActive
   */
  function resetTabs(accordionTabs, keepActive) {
    accordionTabs = accordionTabs != null ? accordionTabs : [];

    for (let i = 0; i < accordionTabs.length; i++) {
      if (keepActive == null || i != keepActive) {
        accordionTabs[i].setAttribute(tabActivData, "false");
        accordionTabs[i]
          .querySelector(accordionControlClass)
          .setAttribute("aria-expanded", "false");

        let tabInner = accordionTabs[i].querySelector(accordionTextClass);
        tabInner.setAttribute("aria-hidden", "true");
        tabInner.style.maxHeight = 0;
      }
    }
  }

  function resetTabsOnResize() {
    // Check for changing width (bugfix mobile browser)
    if (document.body.clientWidth !== documentWidth) {
      documentWidth = document.body.clientWidth;
      resetTabs(document.querySelectorAll(accordionTabClass));
    }
  }

  window.addEventListener("resize", resetTabsOnResize);

  setupAccodion();
})();
